import { useQuery } from '@tanstack/react-query';
import { CompanyService } from '@/infra/services/company';

interface GetCompanyListParams {
	organization_id: string;
}

const Service = CompanyService.getInstance();

export function useGetCompanyList(params: GetCompanyListParams) {
	return useQuery({
		queryKey: ['companies', params],
		queryFn: () => Service.index(params),
		enabled: !!params.organization_id
	});
}
